import { render, staticRenderFns } from "./getBonafideCertificateWws.vue?vue&type=template&id=7977694e&scoped=true&"
import script from "./getBonafideCertificateWws.vue?vue&type=script&lang=js&"
export * from "./getBonafideCertificateWws.vue?vue&type=script&lang=js&"
import style0 from "./getBonafideCertificateWws.vue?vue&type=style&index=0&id=7977694e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7977694e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VRow,VSnackbar,VTextField})
